/**
 * 쿼리챌린지 · 튜닝챌린지 작업 탭(2026-11-04 사용자 요청 — 「다른 작업 창과 동일하게, 닫기(X)도」).
 *
 * 예전에는 두 챌린지가 SQL 편집 탭 안에서 **편집기 자리를 대신**했고, 한쪽을 열면 다른 쪽이 바뀌었다(같은 칸).
 * 이제 종류마다 따로 열리는 작업 탭이다 — 둘 다 열어 두고 오갈 수 있고, 탭의 ✕ 로 닫는다.
 * 창 제목은 **메뉴와 같은 문구**(menu:challenge.query · menu:challenge.tuning) — 메뉴에서 다시 고르면 그 탭이 앞으로 온다.
 * 챌린지 데이터(목록·문항·참여)는 리덕스에 챌린지 번호별로 있어 두 탭이 함께 열려도 섞이지 않는다.
 * 고른 챌린지 기억은 종류마다 따로다(QueryChallenge 의 mode).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiAward, FiZap } from 'react-icons/fi';
import AppModal from '../common/AppModal';
import QueryChallenge from '../QueryChallenge';
import './ChallengeWindow.css';

export default function ChallengeWindow({ open, mode, onClose, draft, onDraftConsumed, onShowPlans }) {
  const { t } = useTranslation();
  const tuning = mode === 'tuning';
  return (
    <AppModal windowed open={!!open} onClose={onClose}
      title={t(tuning ? 'menu:challenge.tuning' : 'menu:challenge.query')}
      icon={tuning ? <FiZap size={14} /> : <FiAward size={14} />}
      className="chw-modal">
      <div className="chw-body challenge-dark-wrapper">
        <QueryChallenge mode={tuning ? 'tuning' : 'query'} onShowPlans={onShowPlans} draft={draft} onDraftConsumed={onDraftConsumed} />
      </div>
    </AppModal>
  );
}

ChallengeWindow.propTypes = {
  open: PropTypes.bool,
  mode: PropTypes.oneOf(['query', 'tuning']).isRequired,
  onClose: PropTypes.func.isRequired,
  draft: PropTypes.object,
  onDraftConsumed: PropTypes.func,
  onShowPlans: PropTypes.func,
};
ChallengeWindow.defaultProps = { open: false, draft: null, onDraftConsumed: undefined, onShowPlans: undefined };
